module.exports = __webpack_public_path__ + "img/trial3-1.2bee01e8.png";